module.exports = __webpack_public_path__ + "img/section27.b9c55d33.png";